const ordersTypes = {
    SAVE_ORDER_HISTORY_START:'SAVE_ORDER_HISTORY_START',
    GET_USER_ORDER_HISTORY_START: 'GET_USER_ORDER_HISTORY_START',
    SET_USER_ORDER_HISTORY:'SET_USER_ORDER_HISTORY'
}

export default ordersTypes;